"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;

var _element = require("@wordpress/element");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _deprecated = _interopRequireDefault(require("@wordpress/deprecated"));

var _blockWrapperElements = _interopRequireDefault(require("./block-wrapper-elements"));

var _useBlockProps = require("./use-block-props");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BlockComponent = (0, _element.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$tagName = _ref.tagName,
      TagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "tagName"]);
  (0, _deprecated.default)('wp.blockEditor.__experimentalBlock', {
    alternative: 'wp.blockEditor.useBlockProps'
  });
  var blockProps = (0, _useBlockProps.useBlockProps)(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  return (0, _element.createElement)(TagName, blockProps, children);
});

var ExtendedBlockComponent = _blockWrapperElements.default.reduce(function (acc, element) {
  acc[element] = (0, _element.forwardRef)(function (props, ref) {
    return (0, _element.createElement)(BlockComponent, (0, _extends2.default)({}, props, {
      ref: ref,
      tagName: element
    }));
  });
  return acc;
}, BlockComponent);

var Block = ExtendedBlockComponent;
exports.Block = Block;
//# sourceMappingURL=block-wrapper.js.map